import React, { useState, useEffect } from "react";
import { Button, Steps, Form, AutoComplete } from "antd/lib";
import { useDispatch, useSelector } from "react-redux";
import {
  PostQuoteHealth,
  CustHealth_detail,
  addhealthnum,
} from "../../Redux/actions/NumHealth";
import { useHistory } from "react-router-dom";
import moment from "moment";
import Healthmake from "../vehicle details/Healthmake";
import axios from "axios";
import HStep1 from "./Step1";
import FloaterMake from "./FloaterMake";
import axiosInHealth from "../../Redux/axios/AxiosInHealth";
const { Step } = Steps;

const HealthStep = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const CusDeatail = useSelector((state) => state?.healthdetail?.cusInfo);
  const PersonsDetail = useSelector(
    (state) => state?.healthdetail?.famdetail?.healthdetail
  );
  const HealthInput = useSelector(
    (state) => state?.healthdetail?.famdetail?.healthIn
  );
  const [current, setCurrent] = useState(0);
  const [form] = Form.useForm();
  const [BaseUrl, setBaseURL] = useState("");
  const [loading, setLoading] = useState(false);
  const [PincodeData, setPincodeData] = useState([]);

  console.log(PersonsDetail);

  useEffect(() => {
    const BASEURL = process.env.REACT_APP_UAT_BASE_URL;
    setBaseURL(BASEURL);
  }, [BaseUrl]);

  const handlePinSearch = (value) => {
    console.log(value);
    axiosInHealth
      .get(`${BaseUrl}v1/health_insurances/pincodes?pincode=${value}`)
      .then((res) => {
        console.log(res?.data);
        const PIData = res?.data;
        console.log(PIData);
        setPincodeData(PIData);
      })
      .then((err) => {
        console.log(err);
      });
  };
  const onFinish = (values) => {
    setLoading(true);
    console.log(values);
    const UpdateCus = {
      ...CusDeatail,
      pincode: values?.Pincode,
    };
    console.log(UpdateCus);
    dispatch(CustHealth_detail(UpdateCus));
    const today = moment();
    console.log(today.format("DD-MM-YYYY"));
    const auth = JSON.parse(localStorage.getItem("vibeReg"));
    const isuser = JSON.parse(localStorage.getItem("vibeUser"));
    if (isuser !== null) {
      var is_POSP = isuser.isPOSP === true ? 1 : 0;
      var posp_id = isuser.isPOSP === true ? isuser.pospid : "";
    } else {
      is_POSP = 0;
      posp_id = "";
    }
    let postHealth = {
      insurance_id: auth?.health_insurance_id,
      subInsuranceProductCode: "HLCP",
      nonAbsProductCode: "DRP01",
      PolicyType: CusDeatail?.planType ? CusDeatail?.planType : "NONFLOATER",
      StartDate: today.format("YYYY-MM-DD"),
      pincode: values?.Pincode,
      policyPeriod: 1,
      suminsured: "500000",
      isPOSP: is_POSP,
      pospId: posp_id,
      persons: PersonsDetail,
      // coverType: '48717'
    };
    const url = `${BaseUrl}v1/health_insurances/register`;
    axios
      .post(url, {
        pincode: values?.Pincode,
        phonenumber: CusDeatail?.phonenumber,
        isPOSP: 0,
      })
      .then((res) => {
        console.log(res);
        let NumData = res?.data?.data;
        console.log(NumData);
        setLoading(false);
        dispatch(addhealthnum(NumData));
        dispatch(PostQuoteHealth(postHealth));
        history.push("/planlayout3");
      })
      .catch((err) => {
        setLoading(false);
        console.log(err?.response?.data);
      });
  };
  const steps = [
    {
      content: (
        <div className="step-container-health">
          <HStep1 setCurrent={setCurrent} current={current} />
        </div>
      ),
    },
    {
      content: (
        <div className="step-container-health">
          <Healthmake setCurrent={setCurrent} current={current} />
        </div>
      ),
    },
    ...(HealthInput?.members?.length > 1
      ? [
          {
            content: (
              <div className="step-container-health">
                <FloaterMake setCurrent={setCurrent} current={current} />
              </div>
            ),
          },
        ]
      : []),
    {
      content: (
        <div className="step-container-health">
          <Form
            form={form}
            layout="vertical"
            className="mx-auto"
            requiredMark={false}
            initialValues={{ field4: "" }}
            onFinish={onFinish}
          >
            <Form.Item
              label="Enter Pincode"
              name="Pincode"
              rules={[
                {
                  pattern: /^(\d{6})$/,
                  message: "Invalid Pincode",
                },
                { required: true, message: "Enter Pincode" },
              ]}
            >
              <AutoComplete
                placeholder="Enter Pincode"
                onSearch={handlePinSearch}
              />
            </Form.Item>
            <Form.Item>
              {PincodeData?.length > 0 ? (
                <div className="pin-sec">
                  <p>Pincode Matched District:</p>
                  <div className="d-flex">
                    {PincodeData?.map((p, index) => (
                      <div key={index}>
                        <div className="pop-cities">{p.district}</div>
                      </div>
                    ))}
                  </div>
                </div>
              ) : null}
              <div className="step-btn-health">
                {current && current > 1 ? (
                  <Button
                    style={{ width: "40%" }}
                    onClick={() => setCurrent(current - 1)}
                  >
                    Back
                  </Button>
                ) : null}
                <Button
                  loading={loading}
                  type="primary"
                  htmlType="submit"
                  style={{ width: "40%" }}
                >
                  Get Quotes
                </Button>
              </div>
            </Form.Item>
          </Form>
        </div>
      ),
    },
  ];
  // console.log(current)
  return (
    <>
      <div className="row justify-content-center health-stepOutr">
        {current === 0 ? (
          <p className="step-ouTr-head">Tell us about yourself</p>
        ) : current === 1 ? (
          <p className="step-ouTr-head">Who would you like to insure?</p>
        ) : current === 2 && HealthInput?.members?.length > 1 ? (
          <p className="step-ouTr-head">
            Which plan would you like to opt for?
          </p>
        ) : current === 2 ||
          (current === 3 && HealthInput?.members?.length > 1) ? (
          <p className="step-ouTr-head">Tell us where you live</p>
        ) : null}
        <div className="d-flex align-items-center justify-content-between">
          <Steps className="step-health-prg" current={current} progressDot>
            {steps?.map((item) => (
              <Step key={item.title} title={item.title} />
            ))}
          </Steps>
        </div>
        <div className="text-center">{steps[current].content}</div>
      </div>
    </>
  );
};

export default HealthStep;
